import { JobLocationsActionButtons } from "./JobLocationActionButtons";

const ParcelActionButtons = () => <JobLocationsActionButtons />;

export default ParcelActionButtons;
